// JsFromRoutes CacheKey b76bfb469ca14b9f9b4c98f68f35dd7c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  unsubscribe: /* #__PURE__ */ definePathHelper('get', '/consumer/users/subscriptions/:encoded_email/unsubscribe'),
  confirmUnsubscribe: /* #__PURE__ */ definePathHelper('post', '/consumer/users/subscriptions/:encoded_email/confirm_unsubscribe'),
}
